// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.rentpayment.RentalManagerRentPaymentWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment,
  RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Path,
  RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments,
  RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Path,
  RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GetListingAcceptsPaymentResponseDto,
  GetListingsEligibleForPaymentsResponseDto,
  MarkDismissibleActionAcknowledgedRequestDto,
  MarkDismissibleActionAcknowledgedResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Options = UseQueryOptions<
  GetListingAcceptsPaymentResponseDto,
  unknown,
  GetListingAcceptsPaymentResponseDto,
  readonly [string]
>;

const RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_GetKey = () =>
  [RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Path] as const;

export const RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_GetKey(),
    queryFn: () => RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment(httpClient),
  }) as const satisfies QueryOptions;

/**
 * get listing alias of a listing that accepts payment in the user's account
 */
export const useRentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment = ({
  httpClient,
  ...options
}: Omit<RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment.getKey =
  RentalManagerRentPaymentWebApiHandler_getListingAcceptsPayment_GetKey;

export type RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Options = UseQueryOptions<
  GetListingsEligibleForPaymentsResponseDto,
  unknown,
  GetListingsEligibleForPaymentsResponseDto,
  readonly [string]
>;

const RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_GetKey = () =>
  [RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Path] as const;

export const RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_GetKey(),
    queryFn: () => RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments(httpClient),
  }) as const satisfies QueryOptions;

/**
 * get list of listings that are eligible for payments but aren't yet accepting them
 */
export const useRentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments = ({
  httpClient,
  ...options
}: Omit<RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments.getKey =
  RentalManagerRentPaymentWebApiHandler_getListingsEligibleForPayments_GetKey;

export interface RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged_Args {
  postData: MarkDismissibleActionAcknowledgedRequestDto;
}

export type RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged_Options = UseMutationOptions<
  MarkDismissibleActionAcknowledgedResponseDto,
  unknown,
  RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged_Args
>;

/**
 * mark a dismissible action as acknowledged
 */
export const useRentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged = ({
  httpClient,
  ...options
}: Omit<RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged_Args) =>
      RentalManagerRentPaymentWebApiHandler_markDismissibleActionAcknowledged(args.postData, httpClient),
  });
};
